/*
 * @Author: your name
 * @Date: 2020-12-07 18:02:15
 * @LastEditTime: 2020-12-09 20:37:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shopManagement/src/service/basic/exceptionApiList.js
 */
const exceptionApiList = {
  getOrderList: "/after-sales-order/chat/exception-order-list",
  getAbnormalDetail: "/cs/exception-order/detail",
  getAfterOrderDetail: "/after-sales-order/chat/after-sales-order/r4/detail",
  getChatGroups: "/chat-base/group",
  // 与聊天室并列的工单管理(我创建的)
  getWorkOrder: `/work-order-center-web/diabolo/find/created`,
  // 与聊天室并列的工单管理(我受理的)
  getWorkOrderHandle: `/work-order-center-web/diabolo/find/accepted`,
  // 工单详情
  getWorkOrderDetail: `/work-order-center-web/work-order-query/find-external-common-detail`,
  // 新建工单
  //   buildWorkOrder: "/exception-order/dialob/r4",
  buildWorkOrder: "/work-order-center-web/create",
  // 新建工单时的问题类型
  workOrderType: "/work-order-center-web/diabolo/work-order-type",
  // 筛选条件展示的二级工单类型
  secondWorkOrderType: "/work-order-center-web/find-second-work-order-type",
  // 添加图片
  addImg: "/work-order-center-web/oss/upload-image",
  // 上传视频
  addVideo: "/work-order-center-web/oss/upload-file",
  // 添加备注
  addRemark: "/work-order-center-web/diabolo/add-remark",
  // 修改状态
  changeStatus: "/work-order-center-web/diabolo/change-status",
  // 判断售后单 or 售后大单
  // getAsOrderInfo:'/v3/internal/aftersale/getAsOrderInfo'
  getAsOrderInfo: "/work-order-center-web/diabolo/find-order-type",
  // 2021-12-03
  // 售后单-新建工单-同步售后图片
  aftersaleImg: "/work-order-center-web/business-record-images",
  // 工单详情页添加补充图片
  additionalImage: "/work-order-center-web",
  // 工单详情页删除补充图片
  deleteImage: "/work-order-center-web",
  //获取售后单各种总数
  queryAsOrderTotalnum: "/system/as_order/totalnum",
  //获取对应的工单类型
  exceptionTypeList: "/work-order-center-web/type-list-adapter",
  // 根据二级工单类型查询快捷回复
  exceptionOrderReply: "/work-order-center-web/find-replay-adapter"
};
export default exceptionApiList;



// WEBPACK FOOTER //
// ./src/service/basic/exceptionApiList.js